import client from '../base-api';

const serviceURL = '/system-monitoring';

const systemMonitoringService = {
    getCronExecutions(filterData: any) {
        return client.get(`${serviceURL}/cron-execution`, {params: filterData});
    },
    getSystemExceptionLogs(filterData: any) {
        return client.get(`${serviceURL}/system-exception-log`, {params: filterData});
    },
    getMessengerExecutionLogs(filterData: any) {
        return client.get(`${serviceURL}/messenger-execution-log`, {params: filterData});
    },
}

export default systemMonitoringService;
